// extracted by mini-css-extract-plugin
export default {"img":"JoinRewardsProgram_img__cW81-","body":"JoinRewardsProgram_body__9RzA8","appButton":"JoinRewardsProgram_appButton__i4P0k","smallPrint":"JoinRewardsProgram_smallPrint__2AfuP"};